import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function FeaturedUpdate() {
  return <section className="py-20 md:py-28 px-4 md:px-8" data-id="element-248" data-mp="2x41ac6amo19z">
      <div className="max-w-[1400px] mx-auto" data-id="element-249" data-mp="2j5tg464z7e2i">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="grid grid-cols-1 lg:grid-cols-5 gap-0 bg-forest text-bone overflow-hidden" data-id="element-250" data-mp="2j51jqt3k1cb6">
          <div className="lg:col-span-3 relative min-h-[320px] lg:min-h-[520px] overflow-hidden group" data-id="element-251" data-mp="20d8qqyohjr3g">
            <img src="https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?auto=format&fit=crop&q=80" alt="Líderes y lideresas en formación geográfica" className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-252" data-mp="1qgvxu30rlh9r" />
            <div className="absolute top-6 left-6 bg-clay text-bone px-4 py-2 text-xs font-bold uppercase tracking-widest flex items-center gap-2" data-id="element-253" data-mp="2zqa8drisrnma">
              <Sparkles size={14} data-id="element-254" data-mp="3dn5twjg8j7j8" />
              El proyecto en una mirada
            </div>
          </div>

          <div className="lg:col-span-2 p-8 md:p-12 lg:p-14 flex flex-col justify-center" data-id="element-255" data-mp="39lu2c8dswc8e">
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl leading-[1.1] mb-6" data-id="element-256" data-mp="2lvzslzos33sd">
              Información geográfica al servicio de los territorios y las
              comunidades
            </h2>
            <p className="text-bone/80 font-light leading-relaxed mb-4" data-id="element-257" data-mp="2us8s1ecra2ei">
              El Proyecto TEFOS articula el ordenamiento del territorio, el
              Catastro Multipropósito —incluyendo su implementación en
              territorios indígenas—, los acuerdos de conservación ambiental y
              la apropiación de la información geográfica para fortalecer la
              gobernanza ambiental y territorial en Colombia. Este esfuerzo se
              apoya en la formación geográfica intercultural de la Escuela
              Intercultural de Geografía para la Vida, fundamental para la
              implementación de esta estrategia.
            </p>
            <p className="text-bone/70 font-light leading-relaxed text-sm" data-id="element-258" data-mp="fw8ia0swk6iy">
              Recorre esta página para conocer los avances del Catastro
              Multipropósito en territorios indígenas, los Objetos Territoriales
              Legales y su visor, los acuerdos de conservación en el Parque
              Nacional Natural Paramillo, la plataforma Colombia en Mapas, los
              diplomados virtuales en ordenamiento territorial y ambiental y la
              alianza con la Escuela Intercultural de Geografía para la Vida,
              pilares fundamentales de este esfuerzo colectivo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}